//
// Copyright 2025 DXOS.org
//

/**
 * The glyph for "run AI over this subject", named here because operation and graph-action metadata
 * carry it as a string, where no shared component can hold the convention.
 */
export const AI_ACTION_ICON = 'ph--sparkle--regular';

/**
 * https://phosphoricons.com
 * NOTE: Select icons that we are unlikely to use for the UI.
 */
export const icons = [
  'ph--house-line--regular',
  'ph--planet--regular',
  'ph--castle-turret--regular',
  'ph--snowflake--regular',
  'ph--virus--regular',
  'ph--graph--regular',
  'ph--air-traffic-control--regular',
  'ph--asterisk--regular',
  'ph--atom--regular',
  'ph--basketball--regular',
  'ph--butterfly--regular',
  'ph--cactus--regular',
  'ph--cake--regular',
  'ph--calendar-dots--regular',
  'ph--campfire--regular',
  'ph--command--regular',
  'ph--confetti--regular',
  'ph--detective--regular',
  'ph--disco-ball--regular',
  'ph--dna--regular',
  'ph--factory--regular',
  'ph--flag-banner-fold--regular',
  'ph--flask--regular',
  'ph--flower-lotus--regular',
  'ph--flying-saucer--regular',
  'ph--game-controller--regular',
  'ph--gavel--regular',
  'ph--gift--regular',
  'ph--guitar--regular',
  'ph--hamburger--regular',
  'ph--handshake--regular',
  'ph--heart--regular',
  'ph--lightbulb--regular',
  'ph--lock--regular',
  'ph--martini--regular',
  'ph--medal-military--regular',
  'ph--moped-front--regular',
  'ph--office-chair--regular',
  'ph--paint-brush-household--regular',
  'ph--peace--regular',
  'ph--person-simple-hike--regular',
  'ph--piggy-bank--regular',
  'ph--potted-plant--regular',
  'ph--radioactive--regular',
  'ph--rocket-launch--regular',
  'ph--shield-star--regular',
  'ph--shopping-cart--regular',
  'ph--stethoscope--regular',
  'ph--student--regular',
  'ph--sun--regular',
  'ph--tote--regular',
  'ph--tree--regular',
  'ph--users-three--regular',
  'ph--yin-yang--regular',
];

export const iconValues = icons.map((icon) => icon.match(/ph--(.+)--regular/)?.[1] ?? icon);
